import React, { useContext } from 'react';

import { type ContainerProps } from '@chakra-ui/react';

import { type CvAnalysisResponse } from '@/services/api';

type CVAnalysisPageContextValue = {
  nav: React.ReactNode;
  noContainer: boolean;
  containerMaxWidth: ContainerProps['maxW'];
  cvAnalysisResponse?: CvAnalysisResponse;
};

export const CVAnalysisResultPageContext =
  React.createContext<CVAnalysisPageContextValue | null>(null);

export const useCVAnalysisLayoutPageContext = () => {
  const context = useContext(CVAnalysisResultPageContext);
  if (context === null) {
    throw new Error('Missing parent <CVAnalysisResultPageContext> component');
  }
  return context;
};
